<template>
    <div class="text-center">

        <span style="font-weight: 900;font-size: 14px;" class="text-danger mt-30 mb-20">
            <i><strong :style="{ fontWeight: 900 }" class="font-web">{{ value < 180 ? '' : value >= 180 && value < 300 ? 'หักคะแนน เท่ากับขาดงาน 0.5 วัน'
                : 'หักคะแนน เท่ากับขาดงาน 1 วัน ' }}</strong></i>
        </span>
        <br><br>
        <vue-gauge style="font-size: 12px;margin-left: -10px;font-weight: 900;" :refid="'_' + Math.random().toString(36).substr(2, 9)"
            :options="myOptions" />

    </div>
</template>
  
<script>
import VueGauge from "vue-gauge";
export default {
    components: { VueGauge },
    props: {
        title: String,
        value: Number,
    },
    data() {
        return {
            myOptions: {
                chartWidth: '320',
                outerNeedle: true,
                needleValue: (Number.parseInt(this.value) / 300) * 100, // % ของการสาย
                needleColor: "#27005D",
                arcDelimiters: [50, 97],
                arcColors: ["#57C5B6", "#FD8D14", "#C70039"],
                arcLabels: ['180 นาที', ''],
                rangeLabel: ['0 นาที', 'มากกว่า 300 นาที'],
                centralLabel: `${Number.parseInt(this.value)}`,
                rangeLabelFontSize: 14,
                labelsFont: 'Sarabun',
            },
        };
    },
    mounted() {
        console.log(globalThis.innerWidth);
    },
};
</script>
  
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
  